import axios from "axios";



export const searchPeppolClient=async (value,typeSearch='q')=>{

    let url = `/search/1.0/json?${typeSearch}=${value}`
    try{
        let {data}=await axios.get(url,{headers:{'Access-Control-Allow-Origin' : '*',}})
        console.log(data)
        return(data)
    }
    catch(e){
        console.error("Impossible d'executer la requete",e)
    }
    

}